import { BaseConstants } from './baseConstants';

export class OrganizationType extends BaseConstants {
  static readonly dentalClinicWithHomeVisit = new OrganizationType(
    'dentalClinicWithHomeVisit',
    '歯科医院(訪問歯科対応あり)',
    'Dental clinic (with home visits)',
  );
  static readonly dentalClinicWithoutHomeVisit = new OrganizationType(
    'dentalClinicWithoutHomeVisit',
    '歯科医院(訪問歯科対応なし)',
    'Dental clinic (without home visits)',
  );
  static readonly universityHospital = new OrganizationType(
    'universityHospital',
    '大学病院',
    'University hospital',
  );
  static readonly acuteCareHospital = new OrganizationType(
    'acuteCareHospital',
    '急性期病院',
    'Acute care hospital',
  );
  static readonly generalHospital = new OrganizationType(
    'generalHospital',
    '総合病院(ケアミックス病院)',
    'General hospital (care-mix)',
  );
  static readonly convalescentHospital = new OrganizationType(
    'convalescentHospital',
    '回復期病院',
    'Convalescent rehabilitation hospital',
  );
  static readonly longTermCareHospital = new OrganizationType(
    'longTermCareHospital',
    '療養型病院',
    'Long-term care hospital',
  );
  static readonly nursingHome = new OrganizationType(
    'nursingHome',
    '介護施設(特養・老健・有料老人ホーム)',
    'Nursing and residential care facilities',
  );
  static readonly homeNursingStation = new OrganizationType(
    'homeNursingStation',
    '訪問看護ステーション',
    'Home-visit nursing station',
  );
  static readonly clinic = new OrganizationType('clinic', '診療所', 'Clinic');
  static readonly publicHealthCenter = new OrganizationType(
    'publicHealthCenter',
    '区(市)役所、保健所、地域包括支援センター',
    'City office / Public health center / Community support center',
  );
  static readonly others = new OrganizationType('others', 'その他', 'Other');

  private constructor(
    public readonly key: string,
    public readonly label: string,
    public readonly labelEn: string,
  ) {
    super();
  }

  /** 表示言語に応じたラベルを返す。 */
  getLabel(lang?: string): string {
    return lang?.startsWith('en') ? this.labelEn : this.label;
  }

  toString() {
    return this.key;
  }

  static getLabelByKey(key: string): string {
    const item = this.getByKey(key);
    return item?.label || key;
  }
}
